import React from 'react';
import styles from './DemoSection.module.scss';

const DEMO_URL = 'https://prepal-demo.up.railway.app/';

const DemoSection = () => {
    return (
        <section className={styles.demoSection} aria-label="Try the Demo">
            <div className={styles.inner}>

                {/* Text content */}
                <div className={styles.textCol}>
                    <p className={styles.eyebrow}>LIVE DEMO</p>
                    <h2 className={styles.heading}>
                        See Prepal in&nbsp;Action
                    </h2>
                    <p className={styles.body}>
                        Explore the full experience before you commit — no account needed.
                        Try AI-powered practice questions, instant explanations, and the
                        adaptive scoring system live on our demo environment.
                    </p>
                    <a
                        href={DEMO_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.ctaBtn}
                    >
                        Try Out Demo
                        <span className={styles.arrow} aria-hidden="true">→</span>
                    </a>
                </div>

                {/* Browser mockup */}
                <div className={styles.mockupCol} aria-hidden="true">
                    <div className={styles.browser}>

                        {/* Chrome bar */}
                        <div className={styles.browserBar}>
                            <span className={styles.dot} data-color="red" />
                            <span className={styles.dot} data-color="yellow" />
                            <span className={styles.dot} data-color="green" />
                            <div className={styles.addressBar}>
                                <span className={styles.lockIcon}>🔒</span>
                                <span className={styles.urlText}>www.studyprepal.com</span>
                            </div>
                        </div>

                        {/* Practice screen */}
                        <div className={styles.practiceScreen}>

                            {/* Exam header — mirrors ExaminationHeader */}
                            <div className={styles.examHeader}>
                                <div className={styles.examHeaderLeft}>
                                    <div className={styles.examSection}>Information and Ideas</div>
                                    <div className={styles.examMode}>Practice Mode — Individual Topic</div>
                                </div>
                                <div className={styles.menuBtn}>
                                    <span className={styles.menuLine} />
                                    <span className={styles.menuLine} />
                                    <span className={styles.menuLine} />
                                    <span className={styles.menuBtnLabel}>Menu</span>
                                </div>
                            </div>

                            {/* Content row — question + chatbot */}
                            <div className={styles.contentRow}>

                                {/* Question panel */}
                                <div className={styles.questionPanel}>
                                    {/* Meta row */}
                                    <div className={styles.questionMeta}>
                                        <span className={styles.questionNum}>Question #4</span>
                                        <span className={styles.questionTypeBadge}>Multiple Choice</span>
                                    </div>

                                    {/* White question card */}
                                    <div className={styles.questionCard}>
                                        <p className={styles.questionText}>
                                            The author uses the phrase "relentless march" in
                                            paragraph 2 primarily to suggest that technological
                                            change is —
                                        </p>
                                        <div className={styles.optionsList}>
                                            {[
                                                { key: 'A', text: 'unstoppable and continuous', state: 'wrong' },
                                                { key: 'B', text: 'gradual and barely noticeable', state: '' },
                                                { key: 'C', text: 'inevitable yet ultimately beneficial', state: 'correct' },
                                                { key: 'D', text: 'disruptive but temporary', state: '' },
                                            ].map(({ key, text, state }) => (
                                                <div
                                                    key={key}
                                                    className={`${styles.option}
                                                        ${state === 'wrong' ? styles.optionWrong : ''}
                                                        ${state === 'correct' ? styles.optionCorrect : ''}`}
                                                >
                                                    <div className={`${styles.radio}
                                                        ${state === 'wrong' ? styles.radioWrong : ''}
                                                        ${state === 'correct' ? styles.radioCorrect : ''}`}>
                                                        {state && <div className={styles.radioDot} />}
                                                    </div>
                                                    <span>{key}. {text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Action buttons */}
                                    <div className={styles.actionRow}>
                                        <div />
                                        <button className={styles.nextBtn}>
                                            Next Question
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                {/* Chatbot panel */}
                                <div className={styles.chatPanel}>
                                    <div className={styles.chatHeader}>
                                        <div className={styles.chatHeaderDot} />
                                        <span className={styles.chatHeaderTitle}>Ask Prepal</span>
                                    </div>

                                    {/* Suggestion chips */}
                                    <div className={styles.chips}>
                                        <span className={styles.chip}>Why is A wrong?</span>
                                        <span className={styles.chip}>Explain differently</span>
                                    </div>

                                    {/* Chat messages */}
                                    <div className={styles.chatMessages}>
                                        <div className={styles.chatBubbleUser}>
                                            Why is A wrong?
                                        </div>
                                        <div className={styles.chatBubbleAi}>
                                            <strong>Choice A</strong> says change is
                                            "unstoppable" but misses the author's emphasis
                                            on its positive outcomes. <strong>C</strong> captures
                                            both inevitability <em>and</em> benefit. ✓
                                        </div>
                                    </div>

                                    {/* Input area */}
                                    <div className={styles.chatInput}>
                                        <div className={styles.chatInputField}>Ask a follow-up…</div>
                                        <div className={styles.chatSendBtn}>
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                            </div>{/* /contentRow */}
                        </div>{/* /practiceScreen */}
                    </div>{/* /browser */}
                    <div className={styles.glow} />
                </div>

            </div>
        </section>
    );
};

export default DemoSection;
